import { IdentifierDTO } from '@zazume/zzm-base';

export const CityKeys = {
  base: ['city'],
  byId: (id: IdentifierDTO) =>
    [...CityKeys.base, id],
  administrativeAreas: (country: string) => ['cities', 'administrative-areas', country]
};
